import React from 'react';
import { makeStyles, Button } from "@material-ui/core";
import { useTranslation } from 'react-i18next';
import { orderArticleWeightToleranceFactor } from '../../../Config/constants'
import { orderArticleLengthToleranceFactor } from '../../../Config/constants'
import { orderArticleWidthToleranceFactor } from '../../../Config/constants'
import { orderArticleThicknessToleranceFactor } from '../../../Config/constants'

export default function ToleranceIndicator(props) {
    const classes = useStyles();
    const { t } = useTranslation();

    let negTolerance = 0
    let posTolerance = 0
    let outNegToleranceWidth = 25
    let inNegToleranceWidth = 25
    let outPosToleranceWidth = 25
    let inPosToleranceWidth = 25

    if (props.name) {
        if (props.name.includes('Weight')) {
            negTolerance = - parseFloat(props.metaData[0].MassDensity.MinTolerance)
            posTolerance = parseFloat(props.metaData[0].MassDensity.MaxTolerance)
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].MassDensity.Value)) * props.toleranceFactor
            outNegToleranceWidth = 100 - inNegToleranceWidth
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].MassDensity.Value)) * props.toleranceFactor
            outPosToleranceWidth = 100 - inPosToleranceWidth
        }
        else if (props.name.includes('Length')) {
            negTolerance = - parseFloat(props.metaData[0].Length.MinTolerance)
            posTolerance = parseFloat(props.metaData[0].Length.MaxTolerance)
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].Length.Value)) * props.toleranceFactor
            outNegToleranceWidth = 100 - inNegToleranceWidth
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].Length.Value)) * props.toleranceFactor
            outPosToleranceWidth = 100 - inPosToleranceWidth
        }
        else if (props.name.includes('Width')) {
            negTolerance = - parseFloat(props.metaData[0].Width.MinTolerance)
            posTolerance = parseFloat(props.metaData[0].Width.MaxTolerance)
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].Width.Value)) * props.toleranceFactor
            outNegToleranceWidth = 100 - inNegToleranceWidth
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].Width.Value)) * props.toleranceFactor
            outPosToleranceWidth = 100 - inPosToleranceWidth
        }
        else if (props.name.includes('Thickness')) {
            negTolerance = - parseFloat(props.metaData[0].Thickness.MinTolerance)
            posTolerance = parseFloat(props.metaData[0].Thickness.MaxTolerance)
            inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.metaData[0].Thickness.Value)) * props.toleranceFactor
            outNegToleranceWidth = 100 - inNegToleranceWidth
            inPosToleranceWidth = (posTolerance / parseFloat(props.metaData[0].Thickness.Value)) * props.toleranceFactor
            outPosToleranceWidth = 100 - inPosToleranceWidth
        }
    }
    else if (props.qualityCheck) {
        negTolerance = - parseFloat(props.qualityCheck.toleranceMin)
        posTolerance = parseFloat(props.qualityCheck.toleranceMax)

        
        inNegToleranceWidth = Math.abs(negTolerance / parseFloat(props.qualityCheck.expectedValue)) * props.toleranceFactor
        inPosToleranceWidth = (posTolerance / parseFloat(props.qualityCheck.expectedValue))* props.toleranceFactor
        outNegToleranceWidth = 100 - inNegToleranceWidth
        outPosToleranceWidth = 100 - inPosToleranceWidth
    }

    let negTolBorderRadius = "";
    let posTolBorderRadius = "";
    if(inNegToleranceWidth > 100){
        negTolBorderRadius = "4px 0 0 4px"
        inNegToleranceWidth = 100
    }
    if(inPosToleranceWidth > 100){
        inPosToleranceWidth = 100
        posTolBorderRadius = "0 4px 4px 0"
    }
    if(outPosToleranceWidth > 100){
        outPosToleranceWidth = 100
    }
    if(outNegToleranceWidth > 100){
        outNegToleranceWidth = 100
    }


    return <React.Fragment>
        <div className={classes.negToleranceNumber}>{negTolerance}</div>
        <div className={classes.negTolerance}>
            <div className={classes.outTolerance} style={{ width: outNegToleranceWidth + "%", borderRadius: "4px 0 0 4px" }}></div>
            <div className={classes.inTolerance} style={{ width: inNegToleranceWidth + "%" , borderRadius:negTolBorderRadius}}></div>
        </div>
        <div className={classes.verticalToleranceSplitter}></div>
        <div className={classes.posTolerance}>
            <div className={classes.inTolerance} style={{ width: inPosToleranceWidth + "%" , borderRadius:posTolBorderRadius}}></div>
            <div className={classes.outTolerance} style={{ width: outPosToleranceWidth + "%", borderRadius: "0 4px 4px 0" }}></div>
        </div>
        <div className={classes.posToleranceNumber}>{"+" + posTolerance}</div>

    </React.Fragment>
}


const useStyles = makeStyles({
    posTolerance: {
        width: "calc(35% - 1px)",
        float: "left",
        position: "relative",
        top: "5px"
    },
    negTolerance: {
        width: "calc(35% - 1px)",
        float: "left",
        position: "relative",
        top: "5px"
    },
    verticalToleranceSplitter: {
        width: "2px",
        backgroundColor: "white",
        float: "left",
        height: "8px"
    },
    inTolerance: {
        backgroundColor: "#5CC958",
        height: "8px",
        float: "left",

    },
    outTolerance: {
        backgroundColor: "#FFC4C4",
        height: "8px",
        float: "left",
    },
    posToleranceNumber: {
        float: "left",
        width: "12%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
        paddingLeft: "10px",
        textAlign: "left"
    },
    negToleranceNumber: {
        float: "left",
        width: "12%",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
        fontWeight: '300 !important',
        color: "#020100",
        paddingRight: "10px",
        textAlign: "right"
    }
});